// @ts-nocheck
import { getDispatch } from 'reducers';
import { takeLatest } from 'redux-saga/effects';
import { deleteAPIDataV2, deleteAPIDataV3, getAPIDataV2, getAPIDataV3, patchAPIDataV2, patchAPIDataV3, postAPIDataV3, putAPIDataV3 } from 'utils/api';
import { setBookmarksList } from './reducer';
import * as sagaActions from './sagaActions';
import { putAPIDataV2 } from 'utils/api';
import { fetchGridFiltersAsync } from 'models/dynamicGrid/sagas';
import { toggleLoader } from 'models/loaders/sagaActions';
import { REQUESTS } from 'utils/services/thetaretail/requests';
import { updateGridMeta } from 'models/dynamicGrid/sagaActions';

async function fetchBookmarksList({ payload }) {
	const dispatch = getDispatch();
	dispatch(
		toggleLoader({
			component: 'bookmarks',
			isLoading: true
		})
	);

	try {
		const { data } = await getAPIDataV3({
      service: REQUESTS.GET.GET_BOOKMARKS.service,
      url: REQUESTS.GET.GET_BOOKMARKS.url,
	 queryParams: { tableId: payload?.tableId },
    });
		dispatch(
			setBookmarksList({
				tableId: payload?.tableId,
				bookmarks: data
			})
		);
	} catch (e) {
		console.log(e)
	}


	dispatch(
		toggleLoader({
			component: 'bookmarks',
			isLoading: false
		})
	);
}

async function applyBookmark({ payload }) {
	const dispatch = getDispatch();

	dispatch(toggleLoader({ component: 'bookmarks', isLoading: true }));

	try {
		await putAPIDataV3({
			service: REQUESTS.PUT.APPLY_BOOKMARK.service,
			url: REQUESTS.PUT.APPLY_BOOKMARK.url,
			pathParams: { bookmarkId: payload.bookmarkId },
			body: { tableId: payload.tableId }
		});

		await fetchGridFiltersAsync({ payload });

		dispatch(
			updateGridMeta(payload.tableId, {
				refreshTimestamp: new Date()
			}, true)
		);

		if (payload.onSuccess) {
			payload.onSuccess();
		}
	} catch (e) {
		console.log(e);
	}

	dispatch(toggleLoader({ component: 'bookmarks', isLoading: false }));
}


async function saveBookmark({ payload }) {
	const dispatch = getDispatch();

	dispatch(
		toggleLoader({
			component: 'bookmarks',
			isLoading: true
		})
	);
	const { bookmarkName, tableId, bookmarkId } = payload;
	try {
		if (bookmarkId) {
			await patchAPIDataV3({
        service: REQUESTS.PATCH.CREATE_UPDATE_BOOKMARK.service,
        url: REQUESTS.PATCH.CREATE_UPDATE_BOOKMARK.url,
        pathParams: { bookmarkId },
        queryParams: { bookmarkName, tableId },
      });
		} else {
			await postAPIDataV3({service: REQUESTS.POST.CREATE_UPDATE_BOOKMARK.service, url: REQUESTS.POST.CREATE_UPDATE_BOOKMARK.url, body: { bookmarkName, tableId }});
		}
	} catch (e) {
		console.log(e);
	}
	dispatch(
		toggleLoader({
			component: 'bookmarks',
			isLoading: false
		})
	);
	dispatch(sagaActions.fetchBookmarksList({ tableId }));
}

async function deleteBookmark({ payload }) {
	const dispatch = getDispatch();
	dispatch(
		toggleLoader({
			component: 'bookmarks',
			isLoading: true
		})
	);
  const { bookmarkId, tableId } = payload;
	try {
		await deleteAPIDataV3({
      service: REQUESTS.DELETE.DELETE_BOOKMARK.service,
      url: REQUESTS.DELETE.DELETE_BOOKMARK.url,
      pathParams: { bookmarkId },
    });
	}
	catch (e) {
		console.log(e)
	}

	dispatch(
		toggleLoader({
			component: 'bookmarks',
			isLoading: false
		})
	);
	dispatch(sagaActions.fetchBookmarksList({ tableId }));
}

export default function* rootSaga() {
	return [
		yield takeLatest(sagaActions.fetchBookmarksList, fetchBookmarksList),
		yield takeLatest(sagaActions.applyBookmark, applyBookmark),
		yield takeLatest(sagaActions.deleteBookmark, deleteBookmark),
		yield takeLatest(sagaActions.saveBookmark, saveBookmark)
	];
}
